<template>
  <div
    :key="locale"
    :style="{
      'padding': !isSimulation && isDesktop ? '15px 30px 15px 30px' : '15px' 
    }"
  >
    <v-card
      class="mx-auto"
    >
      <v-img
        v-if="data.SiteImage"
        :src="data.SiteImage"
        height="200px"
        :style="{ 
            'max-width': isSimulation ? '345px' : `${(sizeW - 30)}px !important`
          }"
      />

      <v-card-title>
        <div style="width:100%;" v-if="title && title.length > 0" v-html="title" class="siteTitle" />
        <span
          v-if="subtitle && subtitle.length > 0"
          class="grey--text subtitle-1"
          style="line-height: 1.2;font-weight: 400; color: rgba(0, 0, 0, 0.47); font-size: 12px !important;text-transform: uppercase;margin-bottom: 10px;"
          :style="{ 'color': `${ColorContent} !important` }"
        >
          {{subtitle}}
        </span>
      </v-card-title>

      <v-divider v-if="(data.SiteAddress && data.SiteAddress.length > 0) || (data.SiteLat && data.SiteLat.length > 0  && data.SiteLon && data.SiteLon.length > 0 )" style="margin-left: 15px;margin-right:15px;" />
      <v-layout wrap>
        <v-flex xs9 style="padding:15px 0 15px 15px">
          <span
            v-if="data.SiteAddress && data.SiteAddress.length > 0"
            style="font-weight: 500; color: rgba(0, 0, 0, 0.47); font-size: 12px;"
            :style="{ 'color': ColorContent }"
            @click="handleGoToMap(coordenates)"
          >
            {{$t('site.address', locale)}} : 
          </span> 
          <span
            v-if="data.SiteAddress && data.SiteAddress.length > 0"
            style="text-decoration: none;"
            :style="{ 'color': ColorContent }"
            @click="handleGoToMap(coordenates)"
          >
            {{data.SiteAddress}}
          </span>
        </v-flex>
        <v-flex xs3 v-if="data.SiteLat && data.SiteLon && data.SiteLat.length > 0  && data.SiteLon.length > 0 " style="padding:20px 15px 20px 0;text-align: right">
          <v-btn class="mx-2" fab dark small :color="'#CCCCCC'"
            :elevation="1"
            @click="handleGoToMap(coordenates)"
          >
            <v-icon :color="'#FFFFFF'">mdi-map-marker</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-divider v-if="data.SitePhone && data.SitePhone.length > 0" style="margin-left: 15px;margin-right:15px;" />
      <div v-if="data.SitePhone && data.SitePhone.length > 0" style="width:100%;padding:15px;">
        <span
          style="font-weight: 500; color: rgba(0, 0, 0, 0.47); font-size: 12px;"
          :style="{ 'color': ColorContent }"
        >
          {{$t('site.phone', locale)}} : 
        </span> 
        <a :href="`tel:${data.SitePhone}`"
          style="text-decoration: none;"
          :style="{ 'color': ColorContent }"
        >
          {{data.SitePhone}}
        </a>
      </div>

      <v-divider v-if="data.SiteWeb && data.SiteWeb.length > 0" style="margin-left: 15px;margin-right:15px;" />
      <div v-if="data.SiteWeb && data.SiteWeb.length > 0" style="width:100%;padding:15px;">
        <span
          style="font-weight: 500; color: rgba(0, 0, 0, 0.47); font-size: 12px;"
          :style="{ 'color': ColorContent }"
        >
          {{$t('site.web', locale)}} : 
        </span> 
        <a :href="`${data.SiteWeb}`"
          target="_blank"
          style="text-decoration: none;"
          :style="{ 'color': ColorContent }"
        >
          {{data.SiteWeb}}
        </a>
      </div>

      <v-divider v-if="data.SiteEmail && data.SiteEmail.length > 0" style="margin-left: 15px;margin-right:15px;" />
      <div v-if="data.SiteEmail && data.SiteEmail.length > 0" style="width:100%;padding:15px;">
        <span
          style="font-weight: 500; color: rgba(0, 0, 0, 0.47); font-size: 12px;"
          :style="{ 'color': ColorContent }"
        >
          {{$t('site.email', locale)}} : 
        </span> 
        <a :href="`mailto:${data.SiteEmail}`"
          style="text-decoration: none;"
          :style="{ 'color': ColorContent }"
        >
          {{data.SiteEmail}}
        </a>
      </div>

      <v-card-actions v-if="moreInfo && moreInfo.length > 0">
          <v-btn
            dark      
            block
            :color="'#CCCCCC'"
            @click="show = !show"
            style="margin-bottom:5px;"
          >
            {{ $t(show ? 'site.hideMoreInfo' : 'site.showMoreInfo', locale) }}
          </v-btn>
      </v-card-actions>

      <v-expand-transition>
        <div v-show="show && moreInfo && moreInfo.length > 0">
          <!-- <v-card-text> -->
            <div
              class="result-html"
              :style="{ 'width': isSimulation ? '345px' : `${(sizeW - 30)}px !important`}"
              
            >
              <vue-editor 
                v-model="moreInfo"
                :disabled="true"
                :editor-toolbar="aux"
                
                :style="{ 
                  'color': `${ColorContent} !important`,
                  'width': isSimulation ? '345px' : `${(sizeW - 30)}px !important`
                  }"
              />
            </div>
          <!-- </v-card-text> -->
        </div>
      </v-expand-transition>
      <div
        v-if="data.SiteLink"
        style="padding:10px;"
      >
        <v-btn
          v-if="!data.SiteLinkDialog"
          :color="BGColor"
          dark
          @click="handleGoTo(getTranslation(data.SiteLinkURL, locale))"
          block
          :style="{ color: Color }"
        >
          {{ getTranslation(data.SiteLinkName, locale) }}
        </v-btn>
        <v-dialog
          v-else
          v-model="dialogSite"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              :color="BGColor"
              dark
              v-bind="attrs"
              v-on="on"
              block
              :style="{ color: Color }"
            >
              {{ getTranslation(data.SiteLinkName, locale) }}
            </v-btn>
          </template>
          <v-card>
            <v-toolbar
              dark
              :color="BGColor"
            >
              <v-btn
                icon
                dark
                @click="dialogSite = false"
              >
              <v-icon :style="{ color: Color }">mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title :style="{ color: Color }">{{getTranslation(data.SiteLinkName, locale)}}</v-toolbar-title>
            </v-toolbar>
            <form-cio
              v-if="data.SiteForm"
              :data="data"
              :onSend="handleSendForm"
            />
            <iframe
              :key="lmu"
              v-else-if="data.SiteLinkURL"
              :src="getTranslation(data.SiteLinkURL, locale)" 
              width="100%"
              height="1200"
            /> 
          </v-card>
        </v-dialog>
      </div>
    </v-card>
  </div>
</template>

<script>
  const minToolbar = [[],[],[],[],[],[],[],[],[],[],[],[],[{  }],[]]

  import { mapState } from 'vuex'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import { VueEditor } from "vue2-editor";
  import FormCio from './item54FormCio/Index'
  export default {
    components: {
      VueEditor,
      FormCio,
    },
    props: {
      data: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      show: false,
      aux: minToolbar,
      dialogSite: false,
      lmu: '',
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent', 'BGColor', 'Color']),
      title () {
        return this.data.SiteTitle ? utils.getTranslation (this.data.SiteTitle, this.locale) : ''
      },
      subtitle () {
        return this.data.SiteSubtitle ? utils.getTranslation (this.data.SiteSubtitle, this.locale) : ''
      },
      moreInfo () {
        return this.data.SiteMoreInfo ? utils.getTranslation (this.data.SiteMoreInfo, this.locale) : ''
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop() {
        return !utils.isMobile()
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      },
      coordenates () {
        return `https://maps.google.com/?q=${this.data.SiteLat}%2C${this.data.SiteLon}`
      }
    },
    watch: {
      dialogSite () {
        this.lmu = new Date().toISOString()
      },
    },
    mounted () {
      //if (!this.data.SiteLinkName) this.data.SiteLinkName = { es: '' }
      //if (!this.data.SiteLinkURL) this.data.SiteLinkURL = { es: '' }
    },
    methods: {
      getTranslation(v, locale) {
        return v ? utils.getTranslation (v, locale) : ''
      },
      handleGoTo (v) {
        window.open(
          v,
          '_blank' // <- This is what makes it open in a new window.
        )
      },
      handleGoToMap (v) {
        window.open(
          v,
          '_blank' // <- This is what makes it open in a new window.
        )
      },
      handleSendForm () {
        this.dialogSite = false
      },
    }
  }
</script>
<style>
  .result-html .ql-toolbar.ql-snow {
    height: 0px !important;
    padding: 0px !important;
    border: 0px !important;
  }
  .result-html .ql-container.ql-snow {
    border: 0px !important;
  }
  .result-html .ql-editor {
    min-height: 0px !important;
  }  
  .siteTitle {
    -ms-word-break: break-all;
    word-break: break-all;
    word-break: normal;     /* Sólo WebKit -NO DOCUMENTADO */

    -ms-hyphens: auto;          /* Guiones para separar en sílabas */
    -moz-hyphens: auto;         /*  depende de lang en <html>      */
    -webkit-hyphens: auto;
    hyphens: auto;
  }
</style>
